import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { getFontSize, getSize } from "./auth-service-tools185.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { Input } from "./auth-service-tools299.js";
import classes from "./auth-service-tools561.js";
const InlineInputClasses = classes;
const InlineInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    __staticSelector,
    __stylesApiProps,
    className,
    classNames,
    styles,
    unstyled,
    children,
    label,
    description,
    id,
    disabled,
    error,
    size,
    labelPosition = "left",
    bodyElement = "div",
    labelElement = "label",
    variant,
    style,
    vars,
    mod,
    ...others
  } = _ref;
  const getStyles = useStyles({
    name: __staticSelector,
    props: __stylesApiProps,
    className,
    style,
    classes,
    classNames,
    styles,
    unstyled
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...getStyles("root"),
    ref,
    __vars: {
      "--label-fz": getFontSize(size),
      "--label-lh": getSize(size, "label-lh")
    },
    mod: [{
      "label-position": labelPosition
    }, mod],
    variant,
    size,
    ...others,
    children: /* @__PURE__ */jsxRuntimeExports.jsxs(Box, {
      component: bodyElement,
      htmlFor: bodyElement === "label" ? id : void 0,
      ...getStyles("body"),
      children: [children, /* @__PURE__ */jsxRuntimeExports.jsxs("div", { ...getStyles("labelWrapper"),
        "data-disabled": disabled || void 0,
        children: [label && /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
          component: labelElement,
          htmlFor: labelElement === "label" ? id : void 0,
          ...getStyles("label"),
          "data-disabled": disabled || void 0,
          children: label
        }), description && /* @__PURE__ */jsxRuntimeExports.jsx(Input.Description, {
          size,
          __inheritStyles: false,
          ...getStyles("description"),
          children: description
        }), error && typeof error !== "boolean" && /* @__PURE__ */jsxRuntimeExports.jsx(Input.Error, {
          size,
          __inheritStyles: false,
          ...getStyles("error"),
          children: error
        })]
      })]
    })
  });
});
InlineInput.displayName = "@mantine/core/InlineInput";
export { InlineInput, InlineInputClasses };